import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotMovies from './components/HotMovies';
import CategoryCards from './components/CategoryCards';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return null;
}

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <HotMovies />
        <CategoryCards />
        <LatestUpdates />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}